import {computed, observable, toJS} from 'mobx';
import {getIn} from '../utils';


class JoinedListingItem {
  @observable content = {};

  constructor(content) {
    this.content = content;
  }

  @computed get maxQuantity() {
    return this.content.rentalObjectAccessory.AccessoryRentalObject_Quantity;
  }

  @computed get name() {
    return this.content.rentalObjectAccessory.AccessoryRentalObject_Name;
  }

  @computed get description() {
    return this.content.rentalObjectAccessory.Description;
  }

  @computed get pk() {
    return this.content.rentalObjectAccessory.refRentalAccessoryId;
  }

  @computed get price() {
    return getIn(this.content.rentalAccessoriesObjectOffers, 
      [0, 'selectables', 0, 'Price']);
  }

  @computed get offerPrice() {
    return getIn(this.content.rentalAccessoriesObjectOffers, 
      [0, 'selectables', 0, 'OfferPrice']);
  }

  @computed get prolongationPrice() {
    return getIn(this.content.rentalAccessoriesObjectOffers, 
      [0, 'selectables', 0, 'ProlongationPrice']);
  }

  @computed get flatPrice() {
    return getIn(this.content.rentalAccessoriesObjectOffers, 
      [0, 'selectables', 0, 'FlatPrice']);
  }

  @computed get sumTotalPrice() {
    return getIn(this.content, ['rentalTransactionAccessory','sumTotalPrice']);
  }

  @computed get inTransaction() {
    return this.quantity > 0;
  }

  @computed get isObligatory() {
    return getIn(this.content, ['rentalObjectAccessory', 'IsObligatory'])
  }

  @computed get quantity() {
    if(!this.content.rentalTransactionAccessory) return 0;
    return this.content.rentalTransactionAccessory.quantity
  }

  @computed get bestOffers() {
    return getIn(this.content, ['rentalAccessoriesObjectOffers'], []);
  }

  @computed get hasBestOffers() {
    return this.bestOffers.length > 0;
  }

  quantityChangerId() {
    return getIn(this.content, ['rentalTransactionAccessory', 'idRentalTransaction']);
  }

  transactionUpdater(amount) {
    let updater = {
      RentalAccessoriesObjectOffer: this.content.rentalAccessoriesObjectOffers.map(o => o.content),
    }
    for(let raoo of updater.RentalAccessoriesObjectOffer) {
      for(let rtaos of raoo.RentalTransactionAccessoriesOfferSelectable) {
        rtaos.RentalObjectQuantity = amount;
      }
    }
 
    return updater;
  }

  @computed get transactionOffers() {
    return this.content.rentalTransactionOffers;
  }

}

export class Accessories {
  constructor(rentalObject, bestOffers, rentalTransaction) {
    this.rentalObject = rentalObject;
    this.bestOffers = bestOffers;
    this.rentalTransaction = rentalTransaction;
  }

  @computed get joinedListing() {
    let result = [];
    for(let rentalObjectAccessory of this.rentalObject.accessories) {
      let rentalAccessoriesObjectOffers = [];
      for(let rentalAccessoriesObjectOffer of this.bestOffers.accessoryOffers) {
        for(let rentalTransactionAccessoriesOfferSelectable of rentalAccessoriesObjectOffer.selectables) {
          if(rentalTransactionAccessoriesOfferSelectable.refRentalObjectId === rentalObjectAccessory.refRentalAccessoryId) {
            rentalAccessoriesObjectOffers.push(rentalAccessoriesObjectOffer);
          }
        }
      }
      let rentalTransactionOffers = [];
      for(let rentalTransactionOffer of this.rentalTransaction.offers) {
        if(rentalTransactionOffer.rentalObjectId === rentalObjectAccessory.refRentalAccessoryId) {
          rentalTransactionOffers.push(rentalTransactionOffer);
        }
      }
      let rentalTransactionAccessory = this.rentalTransaction.accessories.find(
        o => o.refRentalObjectId === rentalObjectAccessory.refRentalAccessoryId);

      result.push(new JoinedListingItem({
        rentalObjectAccessory, // Accessory item from RentalObject structure
        rentalAccessoriesObjectOffers, // Offer items from BestRentalTransactionOffers
        rentalTransactionAccessory, // Accessory item from RentalTransaction. If defined, the accessory is in the transaction.
        rentalTransactionOffers, // Offer items from RentalTransaction.
      }));
    }
    return result;
  }

  

}


// WEBPACK FOOTER //
// ./src/aggregate/Accessories.js